// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  config: {
    http: 'https://',
    ws: 'wss://',
    domain: 'dev-miranda.megakit.pro',
    client: '123456',
    registrationServer: 'https://utax-cloud.dev-miranda.megakit.pro',
    routingMachine: 'https://rm.utaxcloud.net',
    addresses: 'https://address.dev-miranda.megakit.pro/search',
    estimate: 'https://estimator.dev-miranda.megakit.pro/v1/estimate', // test estimate request
    estimateV2: 'https://estimator.dev-miranda.megakit.pro/v2/operator',
    tileServer: 'https://tile.utax.com.ua/{z}/{x}/{y}.png',
    telephonyServer: 'https://callrep.utaxcloud.net',
    white_front: 'http://dev-miranda.megakit.pro/stats/#/',
    payment: 'https://dev-miranda.megakit.pro:22223'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts